<template>
   <NuxtLink :to="'/organisation/'+org_id" class="result">
      <h2>{{name}}</h2>
      <p>
         <tisc-flag v-if="loaded" :code="country_code"></tisc-flag>
         <span>{{reg_code}}</span>
      </p>
      <div v-if="name_matches.length" class="mt-5 text-sm">
         <span class="font-heading font-bold">Other names matched: </span>
         <ul>
            <li :key="name_match.id" v-for="name_match in name_matches">{{name_match}}</li>
         </ul>
      </div>
   </NuxtLink>
</template>

<script>
   import tiscFlag from './tiscFlag.vue'
   export default {
      components: {
         tiscFlag
      },
      data() {
         return {
            name: '',
            country_code: '',
            org_id: '',
            reg_code: '',
            name_matches: [],
            loaded: false
         }
      },
      props: ['result'],
      mounted() {
         this.getResult()
      },
      methods: {
         getResult() {
            const first_entry = this.result.entries[0]
            this.org_id = this.result.org_id
            this.name = this.result.name
            this.reg_code = first_entry.reg_code
            this.country_code = this.result.country_code

            for (const [, names] of Object.entries(this.result.highlight)) {
               for (let i = 0; i < names.length; i++) {
                  const matching_name = names[i].trim()
                  if (matching_name !== this.name && !this.name_matches.includes(matching_name)) {
                     this.name_matches.push(matching_name)
                  }
               }
            }
            this.loaded = true
         }
      }

   }
</script>

<style lang='scss' scoped>
   @import '~/assets/SCSS/Base/00_functions.scss';
   @import '~/assets/SCSS/Base/01_variables.scss';
   @import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Vana/result.scss';
</style>